import { isPlatformBrowser } from '@angular/common';
import {Injectable, Inject, PLATFORM_ID } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class LocalStorageService {

    constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

    public set(setItem: any, data: any){
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem(setItem, JSON.stringify(data));
        }
    }

    public get(getItem: any){
        return isPlatformBrowser(this.platformId) ? JSON.parse(localStorage.getItem(getItem) as any) : null;
    }

    public clear(){
        if (isPlatformBrowser(this.platformId)) {
            localStorage.clear();
        }
    }

    public remove(key: any){
        if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem(key);
        }
    }
}
